var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BModal,
    {
      attrs: {
        size: "lg",
        "modal-class": "vue-need-bootstrap",
        "ok-only": "",
        scrollable: "",
        centered: "",
        title: "New file",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
      },
      on: { close: _setup.onClose },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("div", { staticClass: "warning-modal-title" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("g", { attrs: { "clip-path": "url(#clip0_70_33)" } }, [
                      _c("path", {
                        attrs: {
                          d:
                            "M12 1.5C12.6656 1.5 13.2797 1.85156 13.6172 2.42812L23.7422 19.6781C24.0844 20.2594 24.0844 20.9766 23.7515 21.5578C23.4187 22.1391 22.7953 22.5 22.125 22.5H1.87498C1.20467 22.5 0.581229 22.1391 0.248416 21.5578C-0.0843962 20.9766 -0.0797087 20.2547 0.257791 19.6781L10.3828 2.42812C10.7203 1.85156 11.3344 1.5 12 1.5ZM12 7.5C11.3765 7.5 10.875 8.00156 10.875 8.625V13.875C10.875 14.4984 11.3765 15 12 15C12.6234 15 13.125 14.4984 13.125 13.875V8.625C13.125 8.00156 12.6234 7.5 12 7.5ZM13.5 18C13.5 17.6022 13.3419 17.2206 13.0606 16.9393C12.7793 16.658 12.3978 16.5 12 16.5C11.6022 16.5 11.2206 16.658 10.9393 16.9393C10.658 17.2206 10.5 17.6022 10.5 18C10.5 18.3978 10.658 18.7794 10.9393 19.0607C11.2206 19.342 11.6022 19.5 12 19.5C12.3978 19.5 12.7793 19.342 13.0606 19.0607C13.3419 18.7794 13.5 18.3978 13.5 18Z",
                          fill: "#FFC748",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_70_33" } }, [
                        _c("rect", {
                          attrs: { width: "24", height: "24", fill: "white" },
                        }),
                      ]),
                    ]),
                  ]
                ),
                _vm._v("\n            New file\n        "),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c("div", { staticClass: "w-100" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _setup.onAccepted },
                  },
                  [_vm._v("Close")]
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _setup.isModalOpen,
        callback: function ($$v) {
          _setup.isModalOpen = $$v
        },
        expression: "isModalOpen",
      },
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "warning-modal" }, [
        _c(
          "div",
          { staticClass: "warning-modal__warning" },
          [
            _c("p", [
              _vm._v(
                "\n                Templates with multiple files are only supported in "
              ),
              _c("strong", [_vm._v("Shopify")]),
              _vm._v(",\n                "),
              _c("strong", [_vm._v("Etsy")]),
              _vm._v(" and "),
              _c("strong", [_vm._v("Woocommerce")]),
              _vm._v(" stores.\n            "),
            ]),
            _vm._v(" "),
            _c(
              _setup.CCheckbox,
              {
                staticClass: "accept",
                model: {
                  value: _setup.isAccepted,
                  callback: function ($$v) {
                    _setup.isAccepted = $$v
                  },
                  expression: "isAccepted",
                },
              },
              [_c("p", [_vm._v("Don’t show me this message again.")])]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }